/** Modal `<dialog>` and Popover API support; false during SSR means "not known yet". */
export function browserSupportsBrian(): boolean {
  if (typeof window === "undefined") return false;

  const hasModalDialog =
    typeof window.HTMLDialogElement === "function" &&
    typeof window.HTMLDialogElement.prototype.showModal === "function";

  const hasPopover =
    typeof window.HTMLElement === "function" &&
    typeof window.HTMLElement.prototype.showPopover === "function";

  return hasModalDialog && hasPopover;
}
